import { render, staticRenderFns } from "./SearchGoods.vue?vue&type=template&id=1a51a6ea&scoped=true"
import script from "./SearchGoods.vue?vue&type=script&lang=js"
export * from "./SearchGoods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a51a6ea",
  null
  
)

export default component.exports